import script from "./BrandsWeWorkWith.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandsWeWorkWith.vue?vue&type=script&setup=true&lang=js"

import "./BrandsWeWorkWith.vue?vue&type=style&index=0&id=6ac0ce6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac0ce6c"]])

export default __exports__